import React from 'react';

const Eye = () => {
	return (
		<svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2.01677 7.59434C1.90328 7.41464 1.84654 7.32479 1.81477 7.1862C1.79091 7.0821 1.79091 6.91794 1.81477 6.81384C1.84654 6.67525 1.90328 6.5854 2.01677 6.40571C2.95461 4.92072 5.74617 1.16669 10.0003 1.16669C14.2545 1.16669 17.0461 4.92072 17.9839 6.4057C18.0974 6.5854 18.1541 6.67525 18.1859 6.81384C18.2098 6.91794 18.2098 7.0821 18.1859 7.1862C18.1541 7.32479 18.0974 7.41464 17.9839 7.59434C17.0461 9.07932 14.2545 12.8334 10.0003 12.8334C5.74617 12.8334 2.95461 9.07932 2.01677 7.59434Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M10.0003 9.50002C11.381 9.50002 12.5003 8.38073 12.5003 7.00002C12.5003 5.61931 11.381 4.50002 10.0003 4.50002C8.61962 4.50002 7.50034 5.61931 7.50034 7.00002C7.50034 8.38073 8.61962 9.50002 10.0003 9.50002Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export default Eye;
